export default __webpack_public_path__ + "static/media/serverHostingLogo.06eee2c0.svg";